import { create } from "zustand";
import moment, { Moment } from "moment";

interface DateStore {
  selectedDate: Moment;
  setSelectedDate: (date: Moment) => void;
}

const useDateStore = create<DateStore>()((set) => ({
  selectedDate: moment(),
  setSelectedDate: (date) => set({ selectedDate: date }),
}));

export default useDateStore;
